import {
  Component,
  EventEmitter,
  HostListener,
  Input,
  Output,
  SimpleChanges,
} from '@angular/core';
import { Constants } from '@base/src/app/models/constants';
import { Overlay } from '@base/src/app/models/overlay.model';
import { QRButton } from '@base/src/app/models/qr-button.model';

@Component({
  selector: 'qr-overlay',
  templateUrl: './overlay.component.html',
  styleUrls: ['./overlay.component.scss'],
})
export class OverlayComponent {
  @Input() isOverlayVisible: boolean = true;
  @Input() config: Overlay = new Overlay();
  @Output() isOverlayVisibleChange: EventEmitter<boolean> =
    new EventEmitter<boolean>();

  @HostListener('window:keyup', ['$event'])
  keyEvent(event: KeyboardEvent) {
    // Tecla ESC: Cierra overlay
    if (
      event.key == 'Escape' &&
      this.isOverlayVisible &&
      this.config.EscapeClosesDialog !== false //Si true o undefined por default cierra con ESC
    ) {
      this.close();
    }
  }

  buttonClose: QRButton = {
    hierarchy: QRButton.HIERARCHY_3,
    size: QRButton.SIZE_MEDIUM,
    viewValue: 'Cerrar',
    icon: Constants.ICONS.CLOSE,
  };
  originalScrollPosition: number | undefined;

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['isOverlayVisible']) {
      this.handleParentScroll();
    }
  }

  public close(): void {
    this.isOverlayVisible = false;
    this.handleParentScroll();
    this.isOverlayVisibleChange.emit(this.isOverlayVisible);
  }

  handleParentScroll(): void {
    if (this.isOverlayVisible) {
      this.originalScrollPosition = window.scrollY;
      document.body.classList.add('disable-scroll');
      document.body.style.top = '-' + this.originalScrollPosition + 'px';
    } else {
      document.body.classList.remove('ng-scope', 'disable-scroll');
      document.body.style.top = '0px';
      window.scrollTo({ top: this.originalScrollPosition });
    }
  }

  ngOnDestroy() {
    document.body.classList.remove('ng-scope', 'disable-scroll');
    document.body.style.top = '0px';
    window.scrollTo({ top: this.originalScrollPosition });
  }
}
